import React from 'react';


function JackpotDisplay({ jackpot, img }) {

    function formatMoney(amount) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    }
      

    return (
        <div className='jackpot-item'>
            <img src={img} alt="jackpot"></img>
            <h2>{formatMoney(jackpot)}</h2>
        </div>
    ) 
}

export default JackpotDisplay;